<template>
  <div class="home">
    <el-header class="header" v-loading.fullscreen.lock="loading">
      <div
        :style="`width: ${userInfo.ProjectStatus == 1 ? '270px' : '220px'};
          font-weight: bold;
          border-right: 1px solid #ccc;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-flow: wrap;
          font-size: 18px;`"
      >
        <div
          v-if="isTitle"
          style="width: 100%; text-align: center; cursor: pointer"
          class="HomeTitle"
          @click="
            userInfo.ProjectStatus == 1
              ? $router.replace({ path: '/ProjectInfo?id=' + $ProjectId })
              : $router.replace({ path: '/Home' })
          "
        >
          楼宇设备管理平台
        </div>
        <div
          v-if="!isTitle"
          style="
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0px 10px;
            align-items: center;
          "
        >
          <!-- <el-button
            type="primary"
            style="width: 30px; padding: 0; height: 30px"
            @click="
              userInfo.ProjectStatus == 1
                ? $router.replace({
                    path: '/ProjectInfo?id=' + this.$ProjectId,
                  })
                : $router.replace({ path: '/Home' })
            "
          >
            <i class="el-icon-s-home" style="font-size: 20px"></i
          ></el-button> -->
          <el-button type="primary" @click="$router.go(-1)" icon="el-icon-back">
            后退</el-button
          >
          <div
            style="
              font-size: 12px;
              display: flex;
              flex-direction: column;
              flex: 1;
              justify-content: center;
            "
          >
            <div style="text-align: center">当前功能:</div>
            <div
              :style="`font-size: ${
                RouteName?.title.length > 6 ? '12px' : '18px'
              }; text-align: center`"
            >
              {{ RouteName?.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="el-menu-demo">
        <Nav>
          <el-menu
            :default-active="activeName"
            v-if="userInfo.ProjectStatus == 2"
            style="width: 100%"
            mode="horizontal"
            router
            active-text-color="#409EFF"
          >
            <el-menu-item
              index="/HomeInfo"
              popper-class="popper-menu"
              :class="activeName === '/HomeInfo' ? 'active' : ''"
            >
              <template slot="title">
                <i class="el-icon-monitor"></i>
                <span>首页</span>
              </template>
            </el-menu-item>
            <component
              v-for="item in Menu"
              :key="item.title"
              :index="item.path"
              :is="
                item.children && item.children.length > 0
                  ? 'el-submenu'
                  : 'el-menu-item'
              "
              popper-class="popper-menu"
            >
              <template slot="title">
                <i :class="[item.icon]"></i>
                <span>{{ item.title }}</span>
              </template>
              <template v-if="item.children && item.children.length > 0">
                <component
                  v-for="val in item.children"
                  :key="val.title"
                  :index="val.path"
                  :is="
                    val.children && val.children.length > 0
                      ? 'el-submenu'
                      : 'el-menu-item'
                  "
                  popper-class="popper-menu"
                >
                  <template slot="title">
                    <i :class="[val.icon]"></i>
                    <span>{{ val.title }}</span>
                  </template>
                  <template v-if="val.children && val.children.length > 0">
                    <component
                      v-for="val2 in val.children"
                      :key="val2.title"
                      :index="val2.path"
                      :is="
                        val2.children && val2.children.length > 0
                          ? 'el-submenu'
                          : 'el-menu-item'
                      "
                      popper-class="popper-menu"
                    >
                      <template slot="title">
                        <i :class="[val2.icon]"></i>
                        <span>{{ val2.title }}</span>
                      </template>
                    </component>
                  </template>
                </component>
              </template>
            </component>
          </el-menu>
          <el-menu
            :default-active="activeName"
            v-else
            class="el-menu-demo"
            mode="horizontal"
            router
            active-text-color="#409EFF"
          >
            <el-menu-item
              :index="'/ProjectInfo/ProjectAll?id=' + this.$ProjectId"
              popper-class="popper-menu"
            >
              <template slot="title">
                <i class="el-icon-monitor"></i>
                <span>工作台</span>
              </template>
            </el-menu-item>
            <el-menu-item
              :index="'/ProjectInfo/ChildrenUser'"
              popper-class="popper-menu"
            >
              <template slot="title">
                <i class="el-icon-user"></i>
                <span>子账号管理</span>
              </template>
            </el-menu-item>
          </el-menu>
        </Nav>
      </div>
      <div class="user">
        <el-dropdown
          style="width: 100px"
          placement="bottom-start"
          @command="openAiView"
          v-if="userInfo.ProjectStatus == 2"
        >
          <div
            style="
              display: flex;
              width: 100px;
              align-items: center;
              cursor: pointer;
            "
          >
            <div
              style="
                width: 40px;
                height: 40px;
                background: #409eff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                src="@/assets/AI.png"
                alt=""
                style="width: 20px; height: 20px"
              />
            </div>
            <div
              style="
                margin-left: 5px;
                font-weight: bold;
                font-size: 14px;
                color: #409eff;
              "
            >
              AI助手
            </div>
          </div>

          <el-dropdown-menu
            slot="dropdown"
            style="text-align: center"
            class="aiMenu"
          >
            <!-- <el-dropdown-item command="a">成本分析助手</el-dropdown-item> -->
            <el-dropdown-item command="b">设备数据助手</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div
          style="font-size: 14px; width: 110px; text-align: center"
          v-if="userInfo.ProjectStatus == 2"
        >
          <div>授权码</div>
          <div style="font-weight: bold">{{ userInfo.ProjectCode }}</div>
        </div>
        <div @click="openDevAsDrawer">
          <el-badge
            :value="badgeNum"
            :max="99"
            class="badge"
            :hidden="badgeNum !== 0 ? false : true"
          >
            <div
              style="font-size: 14px; width: 110px; text-align: center"
              class="ellipsis2"
              :title="ProjectInfo.Property_Company || ''"
            >
              {{ ProjectInfo.Property_Company || '' }}
            </div>
          </el-badge>
        </div>
        <el-dropdown size="medium" @command="handleCommand">
          <div
            style="margin: 0 10px; display: flex; align-items: center"
            @click="handleShowUserInfo"
          >
            <el-avatar
              :size="40"
              :src="
                userInfo.ProjectStatus == 2
                  ? userInfo.HeadImg || null
                  : userInfo.Icon || null
              "
              icon="el-icon-user-solid"
            ></el-avatar>

            <div
              style="font-size: 14px; margin-left: 10px; width: 60px"
              class="ellipsis"
              :title="
                userInfo.ProjectStatus == 2
                  ? userInfo.RealName || userInfo.UserName
                  : userInfo.Person || userInfo.PMC_Name
              "
            >
              {{
                userInfo.ProjectStatus == 2
                  ? userInfo.RealName || userInfo.UserName
                  : userInfo.Person || userInfo.PMC_Name
              }}
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user" command="user"
              >用户信息</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-question" command="help"
              >帮助</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-switch-button" command="logout"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-main class="main">
      <div class="wh100" v-if="userInfo.ProjectStatus == 1">
        <router-view></router-view>
      </div>
      <div class="wh100" v-if="userInfo.ProjectStatus == 2">
        <div class="wh100 leftMenu" style="display: flex" v-if="isShowMenu">
          <DevTreeMenu ref="DevTreeMenu" v-if="TreeDataType == 1"></DevTreeMenu>
          <FittingsTreeMenu
            ref="FittingsTreeMenu"
            v-if="TreeDataType == 2"
          ></FittingsTreeMenu>
          <AssetTreeMenu
            ref="AssetTreeMenu"
            v-if="TreeDataType == 3"
          ></AssetTreeMenu>

          <div class="rightCenter">
            <router-view></router-view>
          </div>
        </div>
        <div class="wh100" v-if="!isShowMenu">
          <router-view></router-view>
        </div>
      </div>
    </el-main>
    <el-drawer
      :visible.sync="AIdrawer"
      :modal="false"
      :withHeader="false"
      size="70%"
    >
      <div
        style="width: 100%; height: 100%; overflow: hidden"
        v-loading="AiLoading"
      >
        <!-- :src="`http://119.3.210.33:12000/chatbot/HtlRa9xA7jNZLbsC?name=${encodeParam(
            '设备A'
          )}&code=${encodeParam('132')}`" -->
        <iframe
          :src="AIsrc"
          style="width: 100%; height: 100%; min-height: 700px"
          frameborder="0"
          allow="microphone"
          id="iframe"
          sandbox="allow-scripts allow-same-origin"
          @load="handleIframeLoad"
        >
        </iframe>
      </div>
    </el-drawer>
    <DevDialog
      ref="DevDialog"
      @select="handleDevSelect"
      type="radio"
    ></DevDialog>
    <el-drawer
      :visible.sync="DevAsDrawer"
      size="80%"
      title="15天内需年检设备详情"
    >
      <div style="padding: 10px" class="wh100">
        <el-table
          :data="DevAsData"
          ref="table"
          style="width: 100%"
          height="calc(100% - 40px)"
          v-loading="DevAsLoading"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column
            label="设备编号"
            align="center"
            prop="DeviceCode"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="设备名称"
            align="center"
            prop="device_name"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="设备型号"
            align="center"
            prop="model_number"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="设备规格"
            align="center"
            prop="specification"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="生产厂家"
            align="center"
            prop="manufacturer"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="维修商名称"
            align="center"
            prop="maintenance"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="安装位置"
            align="center"
            prop="InstallationAreaName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="供应商"
            align="center"
            prop="SupplierName"
            sortable
          >
          </el-table-column>

          <el-table-column
            label="购置日期"
            align="center"
            prop="purchase_date"
            sortable
          >
            <template slot-scope="scope">
              {{
                scope.row.purchase_date
                  ? moment(scope.row.purchase_date).format('YYYY-MM-DD')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="年检到期日期"
            align="center"
            prop="ExpiryDate"
            sortable
          >
            <template slot-scope="scope">
              {{
                scope.row.ExpiryDate
                  ? moment(scope.row.ExpiryDate).format('YYYY-MM-DD')
                  : ''
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="150">
            <template slot-scope="scope"> </template>
          </el-table-column> -->
        </el-table>
        <div class="footer" v-loading="loading">
          <el-button @click="DevAsDrawer = false">关闭</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import Nav from '@/components/Nav.vue'
import DevTreeMenu from './DevTreeMenu.vue'
import FittingsTreeMenu from './FittingsTreeMenu.vue'
import AssetTreeMenu from './AssetTreeMenu.vue'
import DevDialog from '@/components/DevDialog/DevDialog.vue'
import { gzipToBase64, o, encodeParam } from '@/utils/compress/compress'
import moment from 'moment'
export default {
  data() {
    return {
      o,
      moment,
      AIsrc: '',
      gzipToBase64,
      encodeParam,
      activeName: '1',
      date: '',
      userInfo: {},
      Menu: [],
      ProjectInfo: {},
      isBefor: true,
      loading: false,
      AIdrawer: false,
      AiLoading: false,
      eventSource: null,
      realData: {},
      MenuList: [],
      activeIndex: '',
      TreeData: [],
      badgeNum: 0,
      DevAsDrawer: false,
      DevAsData: [],
      DevAsLoading: false,
    }
  },
  props: {},
  components: { Nav, DevDialog, DevTreeMenu, FittingsTreeMenu, AssetTreeMenu },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'user':
          this.handleShowUserInfo()
          break
        case 'help':
          this.dropdown()
          break
        case 'logout':
          this.handleExit()
          break
      }
    },
    getDevAsData() {
      this.DevAsData = []
      this.DevAsLoading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/DeviceItem/GetDeviceAnnualInspectioningList',
          {}
        )
        .then((res) => {
          this.DevAsLoading = false
          if (res.Success) {
            this.DevAsData = res.Data || []
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    openDevAsDrawer() {
      console.log(1)
      if (this.badgeNum != 0) {
        this.DevAsDrawer = true
        this.getDevAsData()
      }
    },
    dropdown(a) {
      window.open('http://120.46.133.253:10002/')
    },

    async getTreeData() {
      // TreeDataType 0 无左侧 1 设备 2 备件 3 资产
      await this.$http
        .post('/Base_Manage/Base_Action/GetActionDataList', {})
        .then((res) => {
          let data = res.Data?.filter(
            (item) =>
              item.TreeDataType == 1 ||
              item.TreeDataType == 2 ||
              item.TreeDataType == 3
          )
          this.TreeData = data || []
        })
    },
    handleDevSelect(arr) {
      console.log(arr)
      this.AIdrawer = true
      this.AIsrc = `https://ai.woweitech.com/chat/38iJG7H65wgnUP2Z?name=${encodeParam(
        arr[0].device_name
      )}&code=${encodeParam(arr[0].DeviceCode)}&projectId=${encodeParam(
        this.userInfo.ProjectId
      )}`
    },
    getIframe() {
      const scrpitwin = document.getElementById('scrpitwin')
      if (scrpitwin) scrpitwin.remove()
      const adscrpit = document.createElement('script')
      adscrpit.id = 'scrpitwin'
      adscrpit.textContent = `
        window.difyChatbotConfig = {
        token: "HtlRa9xA7jNZLbsC",
        baseUrl: "http://119.3.210.33:12000",
        systemVariables: {
          // user_id: 'YOU CAN DEFINE USER ID HERE',
        },
        inputs: {
        name: 'apple',
        code: '123',
        }
      };
      `
      document.body.appendChild(adscrpit)
      console.log('脚本1添加成功')
      // document.body.appendChild(script2);
      const oldScript = document.getElementById('HtlRa9xA7jNZLbsC')
      if (oldScript) oldScript.remove()

      // 创建新脚本
      const script = document.createElement('script')
      script.id = 'HtlRa9xA7jNZLbsC'
      script.src = 'http://119.3.210.33:12000/embed.min.js'

      document.body.appendChild(script)
      console.log('脚本2添加成功')
    },
    async addScriptTag() {
      // 清理旧脚本

      // // 创建新脚本
      // const script2 = document.createElement("script");
      // // script2.id = "HtlRa9xA7jNZLbsC222";
      // script2.textContent = `
      //   window.difyChatbotConfig = {
      //   token: "HtlRa9xA7jNZLbsC",
      //   baseUrl: "http://119.3.210.33:12000",
      //   systemVariables: {
      //     // user_id: 'YOU CAN DEFINE USER ID HERE',
      //   },
      //   inputs: {
      //   name: 'apple',
      //   code: '123',
      //   }
      // };
      // `;

      // document.body.appendChild(script2);
      const oldScript = document.getElementById('HtlRa9xA7jNZLbsC')
      if (oldScript) oldScript.remove()

      // 创建新脚本
      const iframe = document.createElement('iframe')
      iframe.id = 'HtlRa9xA7jNZLbsC'
      iframe.src = 'http://119.3.210.33:12000/chat/HtlRa9xA7jNZLbsC'
      iframe.style = 'width: 100%; height: 100%; min-height: 700px'
      iframe.frameborder = '0'
      iframe.allow = 'microphone'
      console.log(
        document.getElementById('iframe'),
        'document.getElementById("iframe");'
      )
      const container = document.getElementById('iframe')
      container.appendChild(iframe)
      window.difyChatbotConfig = {
        token: 'HtlRa9xA7jNZLbsC',
        baseUrl: 'http://119.3.210.33:12000',
        systemVariables: {
          // user_id: 'YOU CAN DEFINE USER ID HERE',
        },
        inputs: {
          name: 'AAA',
          code: 'AAA',
        },
      }

      console.log('脚本添加成功')
    },

    openAiView(num) {
      console.log(num, '2')
      console.log(1)

      this.AiLoading = true
      if (num === 'a') {
        this.AIdrawer = true
        this.AIsrc = `http://119.3.210.33:12000/chat/0MBXSkaGBdZc0boC`
      } else {
        this.$refs.DevDialog.openDialog()
        // this.AIsrc = `http://119.3.210.33:12000/chatbot/FIaIseZuAqxhwpxt?name=${encodeParam(
        //   "设备A"
        // )}&code=${encodeParam("132")}`;
      }
      this.AiLoading = false
    },
    handleShowUserInfo() {
      if (this.userInfo.ProjectStatus == 2) {
        this.$router.push('/UserInfo')
      } else {
        this.$router.push('/User')
      }
    },
    //退出账号
    handleExit(e) {
      this.$confirm('确认退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        TokenCache.deleteToken()
        this.$store.commit('clearUserInfo')
        this.$router.replace('/')
      })
    },
    getDeviceAnnualInspectioning() {
      this.$http
        .post(
          '/Base_DeviceTreeManage/DeviceItem/GetDeviceAnnualInspectioningCount',
          {}
        )
        .then((res) => {
          this.badgeNum = res.Data || 0
        })
    },
    async getUserInfo() {
      this.loading = true
      await this.$http.post('/Base_Manage/Home/GetOperatorInfo').then((res) => {
        this.loading = false
        if (res.Success) {
          if (res.Data?.UserInfo?.ProjectStatus == 2) {
            this.Menu = res.Data.Permissions
            this.$store.commit('setMenu', res.Data.Permissions)
            window.localStorage.setItem(
              'Menu',
              JSON.stringify(res.Data.Permissions)
            )
          }
          this.userInfo = res.Data?.UserInfo || {}
          this.$store.commit('setUserInfo', res.Data?.UserInfo || {})

          window.localStorage.setItem(
            'userInfo',
            JSON.stringify(res.Data?.UserInfo || {})
          )
        }
      })
      this.getDeviceAnnualInspectioning()
    },
    handleIframeLoad() {
      this.AiLoading = false
    },
  },
  async mounted() {},
  async created() {
    this.ProjectInfo = window.localStorage.getItem('ProjectInfo')
      ? JSON.parse(window.localStorage.getItem('ProjectInfo'))
      : {}
    await this.getUserInfo()
    if (this.userInfo.ProjectStatus == 2) {
      await this.getTreeData()
    }

    // this.isBefor = window.localStorage.getItem("Befor") == 1 ? true : false;
    // console.log(this.isBefor);
  },
  computed: {
    TreeDataType() {
      let data = [...this.TreeData]
      let obj = data.find((item) => {
        return item.Url == this.$route.path
      })
      if (obj) {
        return obj.TreeDataType
      } else {
        return null
      }
    },
    isShowMenu() {
      let data = [...this.TreeData]
      // console.log(JSON.stringify(data), "ddddddddddd");
      let Index = data.findIndex((item) => {
        return item.Url == this.$route.path
      })
      // console.log(this.$route.path, "this.$route.paththis.$route.path");
      // console.log(Index, "2222222222222222222");
      if (Index !== -1) {
        return true
      } else {
        return false
      }
    },
    isTitle() {
      if (this.userInfo.ProjectStatus == 1) {
        return true
      } else {
        if (
          this.$route.path == '/HomeInfo' ||
          this.$route.path == '/UserInfo'
        ) {
          return true
        } else {
          return false
        }
      }
    },
    RouteName() {
      const currentPath = this.$route.path
      const findPathInMenu = (menu) => {
        for (const item of menu) {
          if (item.path === currentPath) {
            return item
          }
          if (item.children && item.children.length > 0) {
            const found = findPathInMenu(item.children)
            if (found) {
              return found
            }
          }
        }
        return null
      }
      return findPathInMenu(this.Menu)
    },
  },
  watch: {
    userInfo: {
      deep: true,
      immediate: true,
      handler(n, o) {
        console.log(n, '0000000000000000000000000000000000000000000')
      },
    },
    $route: {
      handler(n, o) {
        console.log(n, 'nnnnnnnnnnnnnnnnnnnnnnnnn')
        if (n.path.indexOf('/ProjectInfo') > -1) {
          if (n.path.indexOf('/ProjectInfo/ChildrenUser') > -1) {
            this.activeName = '/ProjectInfo/ChildrenUser'
          } else {
            this.activeName = '/ProjectInfo/ProjectAll?id=' + this.$ProjectId
          }
        } else {
          this.activeName = n.path
        }
        console.log(this.activeName, 'this.activeNamethis.activeName')
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.home {
  width: 100%;
  height: 100%;
  min-width: 1360px;
  min-height: 600px;
  overflow: auto;
}
.header {
  border-bottom: 1px solid #ccc;
  height: 60px;
  padding: 0 20px;
  padding-right: 20px;
  padding-left: 0px;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  .title {
    width: 220px;
  }
  .user {
    width: 460px;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .el-menu-demo {
    width: calc(100% - 680px);
  }
}
::v-deep .el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu {
  float: none !important;
  display: inline-block !important;
}
.main {
  padding: 0;
  height: calc(100% - 60px);
  background: #ffffff;
}
.menu-item {
  line-height: 40px !important;
  height: 40px !important;
}
::v-deep .el-menu-demo .is-active {
  .el-submenu__title i {
    color: #409eff;
  }
}
::v-deep .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  outline: 0;
  color: #409eff;
  background: #ecf5ff;
  i {
    color: #409eff;
  }
}
.HomeTitle:hover {
  color: #409eff;
}
#iframe .relative {
  display: none !important;
}

.rightCenter {
  width: calc(100% - 220px);
  height: 100%;
}
::v-deep .badge {
  cursor: pointer;
  .el-badge__content .is-fixed {
    transform: translateY(-50%) translateX(60%);
  }
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .active {
  color: #409eff;
  border-bottom-color: #409eff !important;
  i {
    color: #409eff;
  }
}
::v-deep .el-submenu__title,
.el-menu-item {
  font-weight: bold;
  font-size: 16px;
}
::v-deep .leftMenu {
  .el-submenu__title,
  .el-menu-item {
    font-weight: normal;
    font-size: 14px;
  }
}
</style>
